var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon24LogOut = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 3.75c0 .412-.338.75-.75.75H4.5v9h.75c.412 0 .75.338.75.75s-.338.75-.75.75h-1.5c-.413 0-.75-.338-.75-.75V3.75c0-.413.337-.75.75-.75h1.5c.412 0 .75.337.75.75zm7.503 1.819l2.11 3c.188.265.182.621-.013.88l-2.25 3c-.147.197-.373.3-.6.3-.157 0-.315-.048-.45-.15-.332-.247-.398-.718-.15-1.048L13.5 9.75h-6c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h6c.012 0 .024.003.035.007l.03.006-1.29-1.832c-.238-.338-.156-.806.183-1.045.338-.239.806-.156 1.045.183z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon24LogOut, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_24_ log-out.8d511e6f.svg";
export { ForwardRef as ReactComponent };